import React from "react";

const Search = () => {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.5306 18.4696L14.8365 13.7765C16.1971 12.1431 16.8755 10.048 16.7307 7.92715C16.5859 5.80629 15.629 3.82289 14.0591 2.38956C12.4892 0.956234 10.4271 0.183327 8.30188 0.231627C6.17663 0.279927 4.15181 1.14571 2.64864 2.64888C1.14547 4.15205 0.279683 6.17687 0.231383 8.30212C0.183083 10.4274 0.955989 12.4894 2.38932 14.0593C3.82265 15.6293 5.80604 16.5861 7.92691 16.7309C10.0478 16.8757 12.1428 16.1973 13.7762 14.8368L18.4693 19.5308C18.539 19.6005 18.6218 19.6558 18.7128 19.6935C18.8038 19.7312 18.9014 19.7506 19 19.7506C19.0985 19.7506 19.1961 19.7312 19.2871 19.6935C19.3782 19.6558 19.4609 19.6005 19.5306 19.5308C19.6003 19.4612 19.6556 19.3784 19.6933 19.2874C19.731 19.1963 19.7504 19.0988 19.7504 19.0002C19.7504 18.9017 19.731 18.8041 19.6933 18.713C19.6556 18.622 19.6003 18.5393 19.5306 18.4696ZM1.74997 8.50021C1.74997 7.16519 2.14585 5.86015 2.88755 4.75011C3.62925 3.64008 4.68345 2.77492 5.91686 2.26403C7.15026 1.75314 8.50746 1.61946 9.81683 1.87991C11.1262 2.14036 12.3289 2.78324 13.2729 3.72724C14.2169 4.67125 14.8598 5.87398 15.1203 7.18335C15.3807 8.49273 15.247 9.84993 14.7362 11.0833C14.2253 12.3167 13.3601 13.3709 12.2501 14.1126C11.14 14.8543 9.83499 15.2502 8.49997 15.2502C6.71037 15.2482 4.99463 14.5364 3.72919 13.271C2.46375 12.0056 1.75195 10.2898 1.74997 8.50021Z"
          fill="#676565"
        />
      </svg>
    </>
  );
};

export default Search;
